define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 2
// module chunks = 0